import PropTypes from 'prop-types';

export const ANY_CHILD = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node)
]);

export const SEARCH_TYPE = PropTypes.oneOf([
    'address',
    'destination',
    'event',
    'venue',
    'city',
    'airport'
]);

export const SPOT_IMAGES = PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    alt: PropTypes.string
}));

export const CITY_INFO = PropTypes.shape({
    address: PropTypes.string,
    city: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    phoneNumber: PropTypes.string,
    phoneNumberFriendly: PropTypes.string,
    monthlyPhoneNumber: PropTypes.string,
    monthlyPhoneNumberFriendly: PropTypes.string,
    state: PropTypes.string,
    street: PropTypes.string,
    supportEmail: PropTypes.string,
    zipCode: PropTypes.string,
    weekdayHours: PropTypes.string,
    weekendHours: PropTypes.string
});

export const CHECKOUT_PROPS = {
    isFetchingRates: PropTypes.bool,
    selectedRate: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.bool
    ]),
    checkoutError: PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string,
        errors: PropTypes.arrayOf(PropTypes.string)
    }),
    highlightAccountPanel: PropTypes.bool.isRequired,
    onReserveClick: PropTypes.func.isRequired,
    onApplePayReserveClick: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onBackToSearchClick: PropTypes.func,
    isMonthly: PropTypes.bool,
    cityInfo: CITY_INFO.isRequired,
    showApplePay: PropTypes.bool.isRequired,
    licensePlateRequired: PropTypes.bool,
    iDontKnowVehicleSelected: PropTypes.bool,
    focusGuestLogin: PropTypes.bool,
    focusUserAuthentication: PropTypes.bool,
    pageLoaded: PropTypes.bool,
    isStaff: PropTypes.bool,
    isHeroPurchasing: PropTypes.bool,
    isFirstView: PropTypes.bool,
    onHeroPurchasing: PropTypes.func,
    onUserChange: PropTypes.func,
    onIDontKnowChanged: PropTypes.func,
    renderUserDetail: PropTypes.func,
    renderReservationDetailsPanelPreview: PropTypes.func,
    renderReservationDetailEdit: PropTypes.func,
    onReservationDetailsContinue: PropTypes.func
};





// WEBPACK FOOTER //
// ./frontend/src/js/utils/prop.js